
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { loadTrackingPixels } from './utils/loadTrackingPixels'
import networkGuard from './lib/networkGuard'

// Inicializar Network Guard ANTES de cualquier otra cosa
networkGuard.initialize();

// Cargar tracking pixels usando el cliente de Supabase
loadTrackingPixels();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
